module.exports = __webpack_public_path__ + "img/2.f677b27a.png";